import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaSearch, FaUserPlus, FaPollH } from 'react-icons/fa'; // Добавил иконку опроса
import { useTranslation } from 'react-i18next';
import './Home.css';

const Home = () => {
  const { t } = useTranslation();

  return (
    <div className="home-wrapper">
      {/* 1. HERO SECTION */}
      <section className="hero-minimal py-5">
        <Container>
          <Row className="align-items-center justify-content-center min-vh-75 g-5">
            <Col lg={7} md={10} className="text-center text-lg-start">
              <h1 className="responsive-h1 fw-bold mb-4" style={{ color: '#006186' }}>
                Объединяем выпускников ОшТУ
              </h1>
              <p className="lead text-secondary mb-5 mx-auto mx-lg-0 custom-max-width">
                Присоединяйся к нам, находи друзей, делись опытом и будь в курсе всех новостей!
              </p>
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                <Button
                  as={Link}
                  to="/register"
                  className="px-5 py-3"
                  style={{
                    backgroundColor: "#006181",
                    borderColor: "#006181",
                    color: "#fff"
                  }}
                >
                  Вступить в ассоциацию
                </Button>
                <Button as={Link} to="/community" variant="outline-dark" className="px-5 py-3 rounded-pill">
                  Присоединиться к сообществу
                </Button>
              </div>
            </Col>
            <Col lg={5} className="d-none d-lg-block">
              <div className="hero-img-container">
                <img src="student.png" alt="Graduates" className="img-fluid floating-img" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- НОВЫЙ РАЗДЕЛ: ОПРОС --- */}
      <section className="py-4 bg-light">
        <Container>
          <div className="survey-box p-4 p-md-5 rounded-5 shadow-sm bg-white border-0 position-relative overflow-hidden">
            <Row className="align-items-center">
              <Col md={8} className="text-center text-md-start">
                <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-3">
                  <div className="icon-box-small bg-primary-subtle p-2 rounded-3 me-3 text-primary">
                    <FaPollH size={24} style={{ color: '#006186' }} />
                  </div>
                  <h3 className="fw-bold mb-3" style={{ color: '#006186' }}>Пройдите опрос чтобы улучшить Ассоциацию</h3>

                </div>

              </Col>
              <Col md={4} className="text-center text-md-end mt-4 mt-md-0">
                <Button
                  as="a"
                  href="http://localhost:5000" // Замени на свою ссылку
                  target="_blank"
                  className="btn-lg rounded-pill px-5 py-3 shadow-sm fw-bold border-0"
                  style={{ backgroundColor: '#ce0303', color: 'white' }}
                >
                  Пройти опрос
                </Button>
              </Col>
            </Row>
            {/* Декоративный элемент фона */}
            <div className="position-absolute top-0 end-0 opacity-05" style={{ transform: 'translate(20%, -20%)' }}>
              <FaPollH size={200} />
            </div>
          </div>
        </Container>
      </section>
      {/* ------------------------- */}

      {/* 2. MISSION */}
      <section className="py-5 bg-white overflow-hidden">
        <Container>
          <Row className="g-5 align-items-stretch">
            <Col lg={7}>
              <div className="pe-lg-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="line-accent me-3"></div>
                  <span className="text-uppercase tracking-widest text-muted small fw-bold">О сообществе</span>
                </div>
                <h2 className="display-6 fw-bold mb-4" style={{ color: '#006186' }}>
                  Ассоциация выпускников ОшТУ
                </h2>
                {/* ... остальной код без изменений ... */}
                <p className="text-dark fs-5 mb-4">
                  Это динамично развивающаяся организация, объединяющая инженеров разных поколений, окончивших наше славное учебное заведение - ОшТУ.
                </p>
                <div className="official-description p-4 rounded-4 bg-light-subtle border-start border-4" style={{ borderColor: '#006186 !important' }}>
                  <p className="mb-0 text-muted small lh-lg">
                    Ассоциация при Центре Карьеры ОшТУ — это добровольное объединение, основанное на решении Ученого Совета и Уставе университета. Наша задача — создание площадки для обмена опытом и поддержки товарищеских связей.
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="mission-grid h-100">
                <div className="mission-card-dark text-white p-4 mb-4 rounded-4 shadow-lg">
                  <h4 className="fw-bold mb-3 d-flex align-items-center">
                    <span className="dot-pulse me-2"></span> Наша миссия
                  </h4>
                  <p className="small opacity-90 mb-0">
                    Миссия Ассоциации – объединение выпускников это динамичное и заинтересованное сообщество созданная для развития профессиональных, творческих и научных связей внутри сообщества и с Университетом.
                  </p>
                </div>

                <div className="contact-card-glass p-4 rounded-4 border">
                  <div className="d-flex align-items-center mb-2">
                    <h6 className="fw-bold mb-0">Местонахождение</h6>
                  </div>
                  <p className="text-muted small mb-0">
                    Кыргызская Республика, г. Ош, ул. Исанова, 81. Центр Карьеры ОшТУ.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 3. CARDS */}
      {/* ... (остальное остается как было) ... */}
    </div>
  );
};

export default Home;